import { TextChar } from "./TextChar";
import { CallbackType, RequestHelper } from "./helper/module";

export class TextCharCollection {

    /** @type {any} */
    #txTextCharCollection;

    /**
     * Wrapper für TXTextControl.TextCharCollection
     * @param {any} txTextCharCollection 
     */
    constructor(txTextCharCollection) {
        this.#txTextCharCollection = txTextCharCollection;
        this.#bindCallbacks();
    }

    /**
     * binding callback functions
     */
    #bindCallbacks() {
        this.#txTextCharCollection.elementAt = this.#txTextCharCollection.elementAt.bind(this.#txTextCharCollection);
    }

    /**
     * Gets the TextChar at the current text input position
     * @param {number} index 
     * @returns {Promise<TextChar>}
     */
    async elementAt(index) {
        return RequestHelper.Promise(this.#txTextCharCollection.elementAt,
            index,
            CallbackType.RequestTextCharCallback,
            CallbackType.ErrorCallback);
    }
}